import React , {useEffect, useCallback, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import * as S from './NameChange.styles';


import NameChangeUI from '../../../stories/components/NameChangeUI/NameChangeUI';
import Modal, {useModal} from '../../../../../hotels-dweb/src/shared/components/Modal';
import NameChangeConfirmPop from '../../../stories/components/NameChangeUI/NameChangeConfirmPop/NameChangeConfirmPop';
import NameChangeStatusPop from '../../../stories/components/NameChangeUI/NameChangeErrorPop/NameChangeErrorPop';

import {
    changeUserName,
    fetchMyTripsDetailsData,
    fetchMyTripNameChangeData,
    myTripDetailsBookingDataSelector,
    myTripDetailsParamsSelector,
    updateSuccessNameMessage,
    updateErrorNameMessage,
  } from '@ibibo/myaccount-reducer';

const NameChange = () => {

    const dispatch = useDispatch();

    const tripDetails = useSelector(myTripDetailsBookingDataSelector);
    const detailsParams = useSelector(myTripDetailsParamsSelector);

    const {isModalOpen: isConfirmModalOpen, closeModal: closeConfirmModal, openModal: openConfirmModal} = useModal();
    const {isModalOpen: isStatusModalOpen, closeModal: closeStatusModal, openModal: openStatusModal} = useModal();

    let bookingId = null;
    if(tripDetails){
        bookingId = tripDetails.booking_id;
    }

    
    const [{msg , status_color, sub_msg}, setPopData] = useState({
        msg: '',
        status_color: '',
        sub_msg: ''
    })

    const [{old_name, new_name}, setUserName] = useState({
        old_name: '',
        new_name: ''
    });

    const [{newFirstName, newLastName}, setNewName] = useState({
        newFirstName: '',
        newLastName: ''
    })


    const fetchMyTripsDetailsData = useCallback(() => {
        return dispatch(fetchMyTripNameChangeData(detailsParams));
    }, [dispatch]);
    
    useEffect(() => {
        fetchMyTripsDetailsData();
    }, []);

    const navigateToMyTrips = () => {
        window.open('/mytrips/', '_self');
    }

    const successCallback = (resp) => {
        dispatch(updateSuccessNameMessage(resp.message));
        openStatusModal();
        setPopData({
            msg: resp.message,
            status_color: resp.status_color || 'green',
            sub_msg: resp.sub_msg || ''
        });
    }

    const errorCallback = (resp) => {
        dispatch(updateErrorNameMessage(resp.message));
        // openStatusModal();
        openStatusModal();
        setPopData({
            msg: resp.message,
            status_color: resp.status_color || 'red',
            sub_msg: resp.sub_msg || ''
        });
    }

    const onUserSubmit = data => {
        openConfirmModal();
        setNewName({
            newFirstName: data.first_name,
            newLastName: data.last_name
        })
        setUserName({
            old_name: tripDetails.name,
            new_name: data.first_name + ' ' + data.last_name});
    }

    const submitNameChange = () => {
        closeConfirmModal();
        const finalData = {
            first_name: newFirstName,
            last_name: newLastName,
            booking_id: bookingId
        }
        dispatch(changeUserName(finalData, successCallback, errorCallback));
    }

    return(
        <>
            {(tripDetails &&
                <S.NameChangeMainWrap>
                    <S.NameChangeOuterWrap>
                        <NameChangeUI tripDetails={tripDetails} submitChange={onUserSubmit}/>
                    </S.NameChangeOuterWrap>
                </S.NameChangeMainWrap>) 
            || null}

            <Modal
                isOpen={isConfirmModalOpen}
                closeModal={closeConfirmModal}
                modalStyles={{
                    width: 'auto'
                }}
            >
                <NameChangeConfirmPop confirmData={{old_name, new_name}} closeModal={closeConfirmModal} confirmName={submitNameChange}/>
            </Modal>

            <Modal
                isOpen={isStatusModalOpen}
                closeModal={closeStatusModal}
                modalStyles={{
                    width: 'auto'
                }}
            >   
                <NameChangeStatusPop data={{msg, status_color, sub_msg}} navigateToMyTrips={navigateToMyTrips}/>
            </Modal>
        </>
    )
}

export default NameChange;